import styled from 'styled-components'

export const Container = styled.div`
  h2 {
    font-size: 16px;
    margin: 0 0 1.2em;
  }

  p {
    margin: 0.6em 0;
  }

  strong {
    font-weight: bold;
  }
`
